import React from "react";
import mdOptions from "@/utils/markdown-to-jsx.config";
import Markdown from "markdown-to-jsx";
import mdContent from "@/public/md/privacy-policy.md";
import { NextSeo } from "next-seo";

import { serverSideTranslations } from "next-i18next/serverSideTranslations";

const translationNamespaces = ["common", "nav", "products"];

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, translationNamespaces)),
    },
  };
};

const Privacy = () => {
  return (
    <>
      <NextSeo
        title="Privacy Policy"
        description="Read AlHayat Foodstuff's privacy policy to learn how your data is handled."
        canonical="https://alhayatfoodstuff.com/privacy"
        openGraph={{
          title: "Privacy Policy",
          description:
            "Read AlHayat Foodstuff's privacy policy to learn how your data is handled.",
        }}
      />
      <section className="container max-w-3xl p-4 pt-16">
        <Markdown options={mdOptions}>{mdContent}</Markdown>
      </section>
    </>
  );
};

export default Privacy;
